import { memo, useState } from "react";
import { Box, TextField, Typography } from "@mui/material";
import { useApi } from "../../../../shared/hooks/useApi";
import CustomTable from "../../../../shared/components/table/custom-table";
import { LoaderComponent } from "../../../../shared/components/loaders/page-loader";
import { ActionsMenu } from "../../../../shared/components/table/custom-actions";
import { StyledButton } from "../../../../shared/components/buttons/custom-button";
import { EditableTable } from "../../../../shared/components/table/inline-edit-table";
import { CustomSelect } from "../../../../shared/components/inputfields/form-elements";
import { Utills } from "../../../../shared/app-configs/utilit";
import { notify } from "../../../../shared/utils/notify.utills";
import { useTransactionCertificateStore } from "../../../../store/transaction-certificates.store";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ITcCertifiedWeightInfo } from "../../tc-models/tc-req-dto/tc-certified-weight-info";
import { useFormActions } from "../../../../shared/hooks/form-builder.hooks";
import { dtrackItService } from "../../tc-service/dtrackit.service";
import { render } from "@testing-library/react";
import { isAdmin } from "../../../../shared/utils/admin-utils";

interface RenderDetailPanelProps {
  row: any;
  data: any;
  hasSubmitTC: boolean;
  TE_ID: any;
  formtype: any;
  country: any;
  stateDescriptionMap: any;
  setStateDescriptionMap: (map: any) => void;
  mapPayLoad: (map: any) => any;
  setPayLoadData: (data: any) => void;
  setNextEnabled: (enabled: boolean) => void;
}

interface RowData {
  tcGeographicWeight: string;
  tcCertifiedRawMaterialCountryOrAreaDescription: string[];
  tcCertifiedRawMaterialStateOrProvinceDescription: string[];
  tcCertifiedRawMaterialCountryOrArea: string[];
  tcCertifiedRawMaterialStateOrProvince: string[];
}

const RenderDetailPanel = memo(
  ({
    row,
    data,
    hasSubmitTC,
    TE_ID,
    formtype,
    country,
    stateDescriptionMap,
    setStateDescriptionMap,
    mapPayLoad,
    setPayLoadData,
    setNextEnabled,
  }: RenderDetailPanelProps) => {
    const rowData = row.original;
    console.log("rowData in RenderDetailPanel:", rowData);

    const [product, setProduct] = useState<any>(
      rowData?.tcGeographicWeightInfo || []
    );
    const [editingRowIndex, setEditingRowIndex] = useState<number>(-1);
    const [selectedCountries, setSelectedCountries] = useState<any>([]);
    const [state, setState] = useState<any>([]);

    const { setStates, isRestrictPopUpSave, setRestrictPopUpSave } =
      useTransactionCertificateStore();

    const formik = useFormik({
      initialValues: {
        tcCertifiedRawMaterialCountryOrAreaDescription: [],
        tcCertifiedRawMaterialCountryOrArea: [],
        tcCertifiedRawMaterialStateOrProvince: [],
        tcCertifiedRawMaterialStateOrProvinceDescription: [],
        tcGeographicWeight: "",
      },
      validateOnChange: true,
      validateOnBlur: true,
      onSubmit: (values) => {
        console.log("Form values:", values);
      },
    });

    const addNewColumn = () => {
      let prodCopy = [...product];
      const newRow = {
        tcCertifiedRawMaterialCountryOrAreaDescription: [],
        tcCertifiedRawMaterialStateOrProvinceDescription: [],
        tcGeographicWeight: "",
        tcCertifiedRawMaterialCountryOrArea: [],
        tcCertifiedRawMaterialStateOrProvince: [],
      };

      prodCopy = [...prodCopy, newRow];
      setProduct(prodCopy);
      setEditingRowIndex(product.length);
      setRestrictPopUpSave(true);
      formik.setValues(newRow);
      formik.setTouched({});
    };

    const { loading } = useApi();

    if (loading) {
      return <LoaderComponent />;
    }

    if (!rowData || rowData.length === 0) {
      return <Typography>No details available.</Typography>;
    }

    const processorColumns = [
      {
        accessorKey: "tcCertifiedRawMaterialCountryOrAreaDescription",
        header: "Country/Area",
        Header: (
          <span>
            {" "}
            <i style={{ color: "red" }}>* </i> Country/Area
          </span>
        ),
        renderEditCell: ({
          value,
          onChange,
        }: {
          value: any;
          onChange: (value: any) => void;
        }) => (
          <CustomSelect
            label=""
            value={value}
            options={country}
            enableSearch={true}
            onChange={(e, index) => {
              console.log("e.target country :: ", e.target.value);
              const selectedCountryValues = Array.isArray(e.target.value)
                ? e.target.value.filter((val: any) => val !== null && val !== undefined && val !== '')
                : [];
              
              setSelectedCountries(selectedCountryValues);
              onChange(selectedCountryValues);
              handleCountryChange(selectedCountryValues, index);
            }}
            multiple
            placeholder="Select Country/Area"
          />
        ),
      },
      // {
      //   accessorKey: "tcCertifiedRawMaterialCountryOrAreaDescription",
      //   header: "Country/Area Description",
      //   Header: <span>  <i style={{ color: 'red' }}>* </i> Country/Area Description</span>,
      // },
      {
        accessorKey: "tcCertifiedRawMaterialStateOrProvinceDescription",
        header: "State/Province",
        Header: (
          <span>
            {" "}
            <i style={{ color: "red" }}>* </i>State/Province
          </span>
        ),
        renderEditCell: ({
          value,
          onChange,
        }: {
          value: any;
          onChange: (value: any) => void;
        }) => (
          <CustomSelect
            label=""
            value={value}
            options={state}
            enableSearch={true}
            onChange={(e, index) => {
              console.log("This function is called");
              const selectedStates = Array.isArray(e.target.value) 
                ? e.target.value.filter((val: any) => val !== null && val !== undefined && val !== '')
                : [];

              if (selectedStates.length > 0) {
                // Create a new map to avoid direct state mutation
                const newStateMap = { ...stateDescriptionMap };
                let mapUpdated = false;

                // For each selected state, check if it's already in the map
                selectedStates.forEach((stateCode) => {
                  if (stateCode && !stateDescriptionMap[stateCode]) {
                    const stateOption = state.find(
                      (option: any) => option.value === stateCode
                    );
                    if (stateOption) {
                      newStateMap[stateCode] = stateOption.label;
                      mapUpdated = true;
                    }
                  }
                });
                console.log("newStateMap------->", newStateMap);
                // Only update the state map if something changed
                if (mapUpdated) {
                  setStateDescriptionMap(newStateMap);
                  console.log("Updated state description map:", newStateMap);
                }
              }

              onChange(selectedStates);
            }}
            multiple
            placeholder="Select State/Province"
          />
        ),
      },
      {
        accessorKey: "tcGeographicWeight",
        header: "Certified Raw Material Weight (kg)",
        renderEditCell: ({
          value,
          onChange,
        }: {
          value: string;
          onChange: (value: string) => void;
        }) => (
          <TextField
            style={{ marginBottom: "16px" }}
            value={value || ""}
            onChange={(e) => {
              const newValue = e.target.value;
              // Only allow numbers with max 2 decimal places
              const regex = /^\d*\.?\d{0,2}$/;
              if (!regex.test(newValue) && newValue !== "") {
                return;
              }

              let totalWeight = parseFloat(rowData?.tcCertifiedWeight) || 0;
              let productCopy = [...product];
              productCopy[editingRowIndex].tcGeographicWeight = newValue;
              let consolidatedWeight = productCopy.reduce(
                (acc: number, item: { tcGeographicWeight: string }) => {
                  const weight = parseFloat(item.tcGeographicWeight) || 0;
                  return acc + weight;
                },
                0
              );
              if (consolidatedWeight > totalWeight) {
                notify(
                  "Certified Raw Material Weight should not exceed the total weight",
                  "error"
                );
                return;
              }
              onChange(newValue);
            }}
            size="small"
            variant="outlined"
          />
        ),
      },
    ];

    const validationSchema = Yup.object().shape({
      tcCertifiedRawMaterialCountryOrAreaDescription: Yup.array()
        .of(Yup.string())
        .required("Country/Area is required"),
      tcCertifiedRawMaterialCountryOrArea: Yup.array()
        .of(Yup.string())
        .required("Country/Area is required"),
      tcCertifiedRawMaterialStateOrProvinceDescription: Yup.array()
        .of(Yup.string())
        .required("State/Province is required"),
      tcCertifiedRawMaterialStateOrProvince: Yup.array()
        .of(Yup.string())
        .required("State/Province is required"),
      tcGeographicWeight: Yup.number()
        .required("Certified Raw Material Weight is required")
        .positive("Weight must be a positive number"),
    });

    const handleCellChange = async (
      rowIndex: number,
      columnId: string,
      value: any
    ) => {
      if (columnId === "tcCertifiedRawMaterialCountryOrAreaDescription") {
        // value is an array of country codes
        let count = country
          .filter((item: { value: string; code: string }) =>
            value.includes(item.value)
          )
          .map((item: { value: string; code: string }) => item.code);

        formik.setFieldValue(
          "tcCertifiedRawMaterialCountryOrAreaDescription",
          value
        );
        formik.setFieldValue("tcCertifiedRawMaterialCountryOrArea", count);

        setProduct((prevData: typeof product) =>
          prevData.map((row: (typeof product)[0], index: number) =>
            index === rowIndex
              ? {
                  ...row,
                  tcCertifiedRawMaterialCountryOrArea: count,
                  tcCertifiedRawMaterialCountryOrAreaDescription: value,
                }
              : row
          )
        );
      } else if (
        columnId === "tcCertifiedRawMaterialStateOrProvinceDescription"
      ) {
        const filteredValue = Array.isArray(value) 
          ? value.filter((v: any) => v !== null && v !== undefined && v !== '')
          : [];
        
        let stateCode = state
          .filter((item: { value: any }) => filteredValue.includes(item.value))
          .map((item: { code: any }) => item.code)
          .filter((code: any) => code !== null && code !== undefined && code !== '');
        
        formik.setFieldValue(
          "tcCertifiedRawMaterialStateOrProvinceDescription",
          filteredValue
        );
        formik.setFieldValue(
          "tcCertifiedRawMaterialStateOrProvince",
          stateCode
        );
        setProduct((prevData: typeof product) =>
          prevData.map((row: (typeof product)[0], index: number) =>
            index === rowIndex
              ? {
                  ...row,
                  tcCertifiedRawMaterialStateOrProvince: stateCode,
                  tcCertifiedRawMaterialStateOrProvinceDescription: filteredValue,
                }
              : row
          )
        );
      } else {
        formik.setFieldValue(columnId, value);
        setProduct((prevData: typeof product) =>
          prevData.map((row: (typeof product)[0], index: number) =>
            index === rowIndex ? { ...row, [columnId]: value } : row
          )
        );
      }
    };

    const handleSaveRow = () => {
      Object.values(formik.errors).forEach((elt: any) => {
        notify(elt, "error");
      });
      const hasCountry = product.every(
        (item: any) =>
          item.tcCertifiedRawMaterialCountryOrArea &&
          item.tcCertifiedRawMaterialCountryOrArea.length > 0
      );
      const hasState = product.every(
        (item: any) =>
          item.tcCertifiedRawMaterialStateOrProvince &&
          item.tcCertifiedRawMaterialStateOrProvince.length > 0
      );

      if (!hasCountry) {
        notify("Country/Area is required for all rows", "error");
        return;
      }

      if (!hasState) {
        notify("State/Province is required for all rows", "error");
        return;
      }
      // //alert(JSON.stringify(formik.errors))
      //(formRef, formik);
      if (editingRowIndex === null || !formik.isValid) return;

      let dataCopy = [...data];
      dataCopy[row.index].tcGeographicWeightInfo = product;

      const tcStandardCertifiedWeightInformationData = mapPayLoad(dataCopy);
      const newTcId: any = TE_ID;

      const enhancedData = tcStandardCertifiedWeightInformationData.map(
        (item: { tcCertifiedRawMaterialInformation: any[] }) => {
          // Update raw materials with descriptions
          const enhancedRawMaterials =
            item.tcCertifiedRawMaterialInformation.map((rawMaterial) => {
              // Get country descriptions from Zustand store as array

              // Get raw material description from Zustand store
              const tcCertifiedRawMaterialCodeDescription =
                useTransactionCertificateStore
                  .getState()
                  .getRawMtrlCodes.find(
                    (option: any) =>
                      option.value === rawMaterial.tcCertifiedRawMaterialCode
                  )?.label || "";

              return {
                ...rawMaterial,
                tcCertifiedRawMaterialCodeDescription:
                  tcCertifiedRawMaterialCodeDescription,
                // tcCertifiedRawMaterialCountryOrAreaDescription: tcCertifiedRawMaterialCountryOrAreaDescription,
                // tcCertifiedRawMaterialStateOrProvinceDescription: tcCertifiedRawMaterialStateOrProvinceDescription
              };
            });

          return {
            ...item,
            tcCertifiedRawMaterialInformation: enhancedRawMaterials,
          };
        }
      );
      console.log(`enhancedData ${JSON.stringify(enhancedData)}`);
      // If you need to integrate this into a payload
      const requestPayload: any = {
        tcId: newTcId, // Replace with a dynamic value if needed
        tcDetails: {
          tcStandardCertifiedWeightInformation: enhancedData,
        },
      };

      setPayLoadData(requestPayload);
      setNextEnabled(false);
      setRestrictPopUpSave(false);
      //("Generated Request Payload:", JSON.stringify(requestPayload, null, 2));
      setEditingRowIndex(-1);
      formik.resetForm();
    };
    const getState = async (country: any) => {
      try {
        //('inside getState')
        const result: any = await dtrackItService.getStateBasedonCountry(
          country
        );
        console.log(`getstates ${JSON.stringify(result.data)}`);
        const states = result.data.map((t: any) => ({
          value: `${t.description_1} (${t.code_1})`,
          label: `${t.description_1} (${t.code_1})`,
          code: t.code_1,
        }));
        setState(states);
        setStates(states);
        // if(states.length > 0 && state.length > 0){
        //   setState((prev:any) => ({
        //     ...prev,
        //     states
        //   }))
        // }
        // else{
        //   setState(states);
        // }
      } catch (err) {
        //(`Error in Fetching Organic Farm Standard Code ${err}`)
      }
    };

    const handleEditRow = (rowIndex: number) => {
      setEditingRowIndex(rowIndex);
      const dataExistIndex = product.findIndex(
        (_: any, index: any) => index === rowIndex
      );
      if (dataExistIndex != -1) {
        const countries = `[${product[
          dataExistIndex
        ]?.tcCertifiedRawMaterialCountryOrArea
          .map((item: any) => `'${item}'`)
          .join(", ")}]`;
        getState(countries);
      }
      setRestrictPopUpSave(true);
      formik.setValues(product[rowIndex]);
    };

    const handleCancelEdit = async () => {
      const currentRowValues = formik.values;

      // Determine if the row being edited is new by comparing `editingRowIndex` with the data length
      const isNewRow = editingRowIndex === product.length - 1;

      try {
        // Validate the row using the Formik validation schema
        await validationSchema.validate(currentRowValues, {
          abortEarly: false,
        });

        if (isNewRow) {
          // If validation passes and it's a new row, keep it in the data
          setProduct((prevData: typeof product) =>
            prevData.map((row: (typeof product)[0], index: number) =>
              index === editingRowIndex ? currentRowValues : row
            )
          );
        } else {
          // If it's an existing row, revert changes
          formik.setValues(product[editingRowIndex]);
        }
      } catch (validationErrors) {
        if (isNewRow) {
          // If validation fails and it's a new row, remove it from the data
          setProduct((prevData: typeof product) => prevData.slice(0, -1));
        } else {
          // If it's an existing row, revert changes
          formik.setValues(product[editingRowIndex]);
        }
      }
      setRestrictPopUpSave(false);
      // Reset editing state and form
      setEditingRowIndex(-1);
      formik.resetForm();
    };

    /**
     * Delete one inline‐table row, rebuild payload, disable Next
     */
    const handleDeleteRow = (rowIndex: number) => {
      // remove locally
      const updated = product.filter((_: any, idx: number) => idx !== rowIndex);
      setProduct(updated);

      let dataCopy = [...data];
      dataCopy[row.index].tcGeographicWeightInfo = updated;

      // rebuild parent payload
      const payload = mapPayLoad(dataCopy);
      setPayLoadData({
        tcId: TE_ID,
        tcDetails: { tcStandardCertifiedWeightInformation: payload },
      });

      // require fresh save before Next
      setNextEnabled(false);
    };

    //   else {
    //     setNextEnabled(true)
    //   }
    //   const payLoadDatas = product.filter((_: any, index: any) => index !== rowIndex)

    //   const tcStandardCertifiedWeightInformationData = mapPayLoad(payLoadDatas)
    //   const newTcId: any = TE_ID
    //   const requestPayload: ITcCertifiedWeightInfo = {
    //     tcId: newTcId,
    //     tcDetails: {
    //       tcStandardCertifiedWeightInformation: tcStandardCertifiedWeightInformationData,
    //     },
    //   };
    //   setPayLoadData(requestPayload)
    // };

    const handleCountryChange = async (newValue: any, index: any) => {
      if (!Array.isArray(newValue) || newValue.length === 0) {
        setState([]);
        // Clear state selections when no countries are selected
        formik.setFieldValue('tcCertifiedRawMaterialStateOrProvinceDescription', []);
        formik.setFieldValue('tcCertifiedRawMaterialStateOrProvince', []);
        return;
      }
      
      // Get country codes for selected countries
      const countryCodes = country
        .filter((count: { value: string; code: string }) =>
          newValue.includes(count.value)
        )
        .map((count: { code: string }) => count.code);

      const formattedCountryCode = `[${countryCodes.map((code: string) => `'${code}'`).join(", ")}]`;
      
      Utills.cl(
        `handleCountryChange ${newValue} formatted: ${formattedCountryCode}`
      );
      
      // Fetch new states for selected countries
      await getState(formattedCountryCode);
      
      const result: any = await dtrackItService.getStateBasedonCountry(formattedCountryCode);
      const validStateCodes = result.data.map((t: any) => t.code_1);
      
      const currentStateDescriptions = formik.values.tcCertifiedRawMaterialStateOrProvinceDescription || [];
      const currentStateCodes = formik.values.tcCertifiedRawMaterialStateOrProvince || [];
      
      const filteredStateDescriptions = currentStateDescriptions.filter((stateDesc: string) => {
        const match = stateDesc.match(/\(([^)]+)\)$/);
        if (match && match[1]) {
          return validStateCodes.includes(match[1]);
        }
        return false;
      });
      
      const filteredStateCodes = currentStateCodes.filter((code: string) => 
        validStateCodes.includes(code)
      );
      
      // Update formik with filtered states
      formik.setFieldValue('tcCertifiedRawMaterialStateOrProvinceDescription', filteredStateDescriptions);
      formik.setFieldValue('tcCertifiedRawMaterialStateOrProvince', filteredStateCodes);
      
      setProduct((prevData: typeof product) =>
        prevData.map((row: (typeof product)[0], idx: number) =>
          idx === editingRowIndex
            ? {
                ...row,
                tcCertifiedRawMaterialStateOrProvince: filteredStateCodes,
                tcCertifiedRawMaterialStateOrProvinceDescription: filteredStateDescriptions,
              }
            : row
        )
      );
    };
    const expectedWeight = parseFloat(rowData.tcGeographicWeight) || 0;
    const currentSum = product.reduce((sum: any, item: any, idx: any) => {
      if (idx === editingRowIndex && editingRowIndex > -1) {
        return sum + (parseFloat(formik.values.tcGeographicWeight) || 0);
      }
      return sum + (parseFloat(item.tcGeographicWeight) || 0);
    }, 0);
    const canSave = currentSum === expectedWeight;
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "#F6F5EF",
          p: 5,
          gap: 4,
          width: "100%",
        }}
      >
        <Box display="flex" justifyContent="flex-end" width="100%">
          {!hasSubmitTC && !isAdmin() && (
            <StyledButton
              variant="contained"
              sx={{ boxShadow: "none" }}
              onClick={addNewColumn}
              disabled={isRestrictPopUpSave}
            >
              Add Geographic Location
            </StyledButton>
          )}
        </Box>
        <Box
          sx={{
            width: "100%",
            textAlign: "left",
            // tighten the gap so it hugs the summary row
            mt: 1,
            mb: 10,
            // light gray background
            // padding inside the panel
            p: 3,
            // subtle rounded corners
            borderRadius: 1,
          }}
          display="grid"
        >
          <Typography variant="body2" fontWeight={"400"} sx={{ mb: 1 }}>
            Weight Information
          </Typography>
          {/* <CustomTable
          columns={processorColumns}
          data={product}
          enableTopToolbar={false}
          enableRowActions={!hasSubmitTC}
          enableBottomToolbar={false}
          renderRowActions={({ row }) => (
            <ActionsMenu row={row} onEdit={()=>{}} onDelete={()=>{}} />
          )}
        /> */}
          <EditableTable
            data={product}
            columns={processorColumns}
            onSaveRow={handleSaveRow}
            onCellChange={handleCellChange}
            editingRowIndex={editingRowIndex}
            onCancelEdit={handleCancelEdit}
            onEditRow={handleEditRow}
            onDeleteRow={handleDeleteRow}
            hideDelete={false}
            enableEditing={!hasSubmitTC}
            // customeEmptyRecordText={true}
            // customeEmptyRecordComponent={customeEmptyRecordComponent}
            formtype={formtype}
            TE_ID={TE_ID}
          />
        </Box>
      </Box>
    );
  }
);

export default RenderDetailPanel;
